import APITemplate from './APITemplate'

export default APITemplate('/io-parameter')
